import { createStore, applyMiddleware, AnyAction } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage/session';
import merge from 'lodash/merge';

import rootReducer from './rootReducer';

const defaultState = rootReducer(undefined, {} as AnyAction);

const persistConfig = {
  key: 'root',
  storage,
  // simple migration to add new fields to the state from default one
  // merge is used for deep copy purpose
  migrate: (state) => Promise.resolve(merge({}, defaultState, state)),
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

function initStore() {
  const middlewareEnhancer = applyMiddleware();
  const composedEnhancer = composeWithDevTools(middlewareEnhancer);

  const store = createStore(persistedReducer, composedEnhancer);
  const persistor = persistStore(store);

  if (module.hot) {
    module.hot.accept('./rootReducer', () => {
      // This fetch the new state of the above reducers.
      // eslint-disable-next-line @typescript-eslint/no-var-requires
      const nextRootReducer = require('./rootReducer').default;
      store.replaceReducer(persistReducer(persistConfig, nextRootReducer));
    });
  }

  return { store, persistor };
}

export { initStore };
